import type { SwitcherProps } from './switcher.types';

export const defaultSwitcherProps: Required<
	Omit<SwitcherProps, 'rowGap' | 'columnGap' | 'limit'>
> = {
	gap: 'spacing-4',
	threshold: '10rem',
};
